<template>
  <div class="d-inline-block">
    <fa-icon icon="calendar-alt" /> {{ date }} <fa-icon icon="clock" /> {{ time }}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'dateDisplay',
  props: {
    timestamp: {
      type: Number,
      default: Date.now()
    },
    dateFormat: {
      type: String,
      default: 'MMMM Do YYYY'
    },
    timeFormat: {
      type: String,
      default: 'HH:mm:ss'
    }
  },
  computed: {
    date () {
      return this.timestamp ? moment(this.timestamp).format(this.dateFormat) : '?'
    },
    time () {
      return this.timestamp ? moment(this.timestamp).format(this.timeFormat) : '?'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/general/DateDisplay.vue